export default __webpack_public_path__ + "static/media/SmartKidsEducare.16a3920f.png";